import React from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import InfoRow from "./InfoRow.tsx";

import { HeatExchangerData } from "../ProjectDetails.types.tsx";

import { SubHeaderLabel } from "../../Labels.tsx";

const HeatExchangerDataCard: React.FC<{ heatExchangerData: HeatExchangerData }> = ({
  heatExchangerData,
  unitSystem,
}) => {
  const { t } = useTranslation();

  const {
    entering_fluid_temperature,
    leaving_fluid_temperature,
    flow_rate,
    fluid,
    pressure_drop,
    fouling_factor,
    evaporator_model,
    evaporator_quantity,
  } = heatExchangerData || {};

  return (
    <Card className="border-0 h-100">
      <Card.Body className="d-flex flex-column">
        <SubHeaderLabel textAlign="left" className="mb-2">
          {t("projectDetails.heatExchangerDataCard.title")}
        </SubHeaderLabel>

        <div className="flex-grow-1">
          <InfoRow
            label={`${t("projectDetails.heatExchangerDataCard.enteringFluidTemp")}:`}
            value={`${parseFloat(entering_fluid_temperature).toFixed(1)} ${t(`units.${unitSystem}.temperature`)}`}
          />
          <InfoRow
            label={`${t("projectDetails.heatExchangerDataCard.leavingFluidTemp")}:`}
            value={`${parseFloat(leaving_fluid_temperature).toFixed(1)} ${t(`units.${unitSystem}.temperature`)}`}
          />
          <InfoRow
            label={`${t("projectDetails.heatExchangerDataCard.flowRate")}:`}
            value={flow_rate}
          />
          <InfoRow label={`${t("projectDetails.heatExchangerDataCard.fluid")}:`} value={fluid} />
          <InfoRow
            label={`${t("projectDetails.heatExchangerDataCard.pressureDrop")}:`}
            value={`${parseFloat(pressure_drop).toFixed(2)} kPa`}
          />
          <InfoRow
            label={`${t("projectDetails.heatExchangerDataCard.foulingFactor")}:`}
            value={fouling_factor}
          />
          <InfoRow
            label={`${t("projectDetails.heatExchangerDataCard.evaporatorType")}:`}
            value={evaporator_model}
          />
          <InfoRow
            label={`${t("projectDetails.heatExchangerDataCard.evaporatorQuantity")}:`}
            value={evaporator_quantity}
          />
        </div>
      </Card.Body>
    </Card>
  );
};

export default HeatExchangerDataCard;
